export const appEngineFilterOperators = {
  acceptedStatusOperators: ['is'],
};
